import { blurayFeatures, formatRows } from '@/mocks/site';

export default function BluraySection() {
  return (
    <section id="bluray" className="scroll-mt-20 bg-primary-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-400 uppercase">
              <i className="ri-disc-line"></i> BLU-RAY ZONE
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-background-50">蓝光原盘 · 高清专区</h2>
            <p className="mt-3 text-sm leading-relaxed text-background-200/85">
              蓝光专区收录了画质与音轨最完整的片源。这里的资源按分辨率与封装方式分类，
              从 4K 原盘到移动端适配版，规格一目了然。下载前对照下面的参数表，就能挑到既清晰又适合自己设备与存储空间的版本。
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {blurayFeatures.map((f) => (
                <div key={f.title} className="p-4 rounded-lg border border-primary-800 bg-primary-900">
                  <span className="w-10 h-10 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center">
                    <i className={`${f.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-semibold text-background-50">{f.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-background-200/75">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-primary-800 bg-primary-900 overflow-hidden">
            <div className="px-5 py-4 border-b border-primary-800 flex items-center justify-between">
              <h3 className="font-heading text-lg font-semibold text-background-50">清晰度规格对照表</h3>
              <span className="text-[11px] text-background-200/70">按体积与场景选择</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full min-w-[440px] text-left text-sm">
                <thead>
                  <tr className="text-xs text-background-200/70 border-b border-primary-800">
                    <th className="px-5 py-3 font-medium">版本</th>
                    <th className="px-3 py-3 font-medium">分辨率</th>
                    <th className="px-3 py-3 font-medium">体积参考</th>
                    <th className="px-5 py-3 font-medium">适合场景</th>
                  </tr>
                </thead>
                <tbody>
                  {formatRows.map((row) => (
                    <tr key={row.format} className="border-b border-primary-800/60 last:border-0">
                      <td className="px-5 py-3.5 font-medium text-background-50 whitespace-nowrap">{row.format}</td>
                      <td className="px-3 py-3.5 text-background-200/85 whitespace-nowrap">{row.resolution}</td>
                      <td className="px-3 py-3.5 text-accent-300 whitespace-nowrap">{row.sizePerHour}</td>
                      <td className="px-5 py-3.5 text-background-200/85 whitespace-nowrap">{row.scene}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="px-5 py-4 bg-primary-900 border-t border-primary-800 flex items-start gap-3">
              <i className="ri-information-line text-secondary-300 text-lg mt-0.5"></i>
              <p className="text-xs leading-relaxed text-background-200/80">
                以上体积为常见参考值，实际大小会因片长、码率与封装方式不同而略有差异。卡片上标注的体积为准确值。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}